import { Toast, ToastContainer } from 'react-bootstrap';
import { MdCheck, MdFlag } from 'react-icons/md';
import { SectionStatus, SectionStatusType } from '../data-qa-constants';

interface ApprovalToastProps {
  show: boolean;
  // What was approved or flagged, e.g. "Media Inputs".
  title: string | null;
  status: SectionStatusType | null;
  onClose: () => void;
}

export const ApprovalToast = ({ show, title, status, onClose }: ApprovalToastProps) => {
  const isApproved = status === SectionStatus.APPROVED;
  const sectionTitle = title ?? 'Section';

  return (
    <ToastContainer position='bottom-end' className='data-qa-toast-container'>
      <Toast
        show={show}
        onClose={onClose}
        delay={4000}
        autohide
        className={`data-qa-toast data-qa-toast--${isApproved ? 'approved' : 'flagged'}`}
      >
        <Toast.Body>
          {isApproved ? <MdCheck size={16} /> : <MdFlag size={16} />}
          <span>
            {sectionTitle} {isApproved ? 'approved' : 'flagged'}
          </span>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};
